(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');
    module.service('AgendaItemResizeObserverService', [
        AgendaItemResizeObserverService
    ]);
    
    function AgendaItemResizeObserverService() {

        const sizes = ['xs', 'sm', 'lg', 'xl'];
        
        if (window.ResizeObserver) {

            const observer = new ResizeObserver(entries => {            
                let sizeClass = '';
    
                entries.forEach(entry => {
                    let width = entry.contentRect.width;
                    
                    entry.target.classList.remove(...sizes);
    
                    if (width < 500) {
                        sizeClass = 'xs';   
                    } else if (width >= 500 && width < 650) {
                        sizeClass = 'sm';
                    } else if (width >= 650 && width < 900) {
                        sizeClass = 'lg';
                    } else if(width >= 900) {
                        sizeClass = 'xl'
                    }
    
                    entry.target.classList.add(sizeClass);
                });
            });
    
            this.observe = function() { 
                observer.disconnect();
    
                const agendaItems = document.querySelectorAll('.agenda-item-container');
    
                agendaItems.forEach(item => observer.observe(item));
            }
    
            this.stopObserving = function() {
                observer.disconnect();
            }
        }
    }
})();